<template>
  <div
    class="app-button-list-item w-full"
    v-on="$listeners"
  >
    <div :class="['app-button-list-item__button', computedStyles, textColorClass(), activeClass]">
      <div class="app-button-list-item__text">
        <slot />
        <span v-if="text">{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import theme from '@/mixins/theme'

export default {
  // Name
  name: 'AppButtonListItem',

  mixins: [theme],

  // Props
  props: {
    text: { // Button text
      type: String,
      default: ''
    },
    active: { // Adds colored border / dropshadow
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Computed
  computed: {
    computedStyles () {
      return {
        'app-button-list-item__button--active font-semibold bg-opacity-20': this.active,
        'border': !this.active
      }
    },
    activeClass () {
      return this.active ? [this.bgColorClass(), this.borderColorClass()] : ''
    }
  }
}
</script>

<style scoped lang="scss">
.app-button-list-item {
  @apply shadow bg-white;

  &__button {
    @apply flex items-center justify-center w-full h-50 px-20 border-collapse text-center cursor-pointer border-solid;

    @screen sm {
      @apply h-60;
    }

    @screen lg {
      &:hover {
        @apply font-semibold bg-gray-100 border-current border-2;
      }
    }

    &--active {
      @apply border-current border-2;
    }
  }

  &__text {
    @apply text-black;
  }
}
</style>
